import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgMaintenance(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 0 18 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.642 13.792l.71.71a1.24 1.24 0 011.755 0l2.693 2.692c.39.391.39 1.024 0 1.415l-1.218 1.218a1 1 0 01-1.414 0l-2.694-2.693a1.242 1.242 0 01-.085-1.661l.085-.094-.71-.71.878-.877zm3.085-9.6L15.433 6.43l2.633 2.567 2.293-2.237a4.078 4.078 0 01-.97 4.366c-1.202 1.172-2.957 1.484-4.478.945l-7.632 7.443a1.001 1.001 0 01-1.396 0l-1.2-1.17a1.002 1.002 0 01-.018-1.415l.018-.017 7.597-7.407a4.077 4.077 0 01.969-4.368c1.202-1.172 2.957-1.484 4.479-.944zM6.519 5.447l1.92 1.378a.55.55 0 01.125.765l-.028.035-.03.033 1.892 1.892-.878.878-1.891-1.893a.548.548 0 01-.833-.068L5.419 6.546a.787.787 0 011.101-1.1z"
      />
    </svg>
  );
}

export default tombacIcon('Maintenance')(SvgMaintenance);
